var map = {
	"./elect.png": "6525",
	"./elect_bed.png": "04a9",
	"./elect_normal.png": "7d0f",
	"./intelLock.png": "feb8",
	"./intelLock_normal.png": "f1a4",
	"./u1002.png": "e5d4",
	"./u1003.png": "16b9",
	"./u1004.png": "6f17",
	"./water.png": "373b",
	"./water_bed.png": "a2ff",
	"./water_normal.png": "fce1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "adb8";